<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>教师绩效->绩效模板配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校" @change="getData">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
 
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  icon="el-icon-plus" @click="setAdd('')">添加</el-button>
                    <el-button type="warning"  @click="createTemplate">生成模板</el-button>
                    <el-button type="primary"  @click="preview">预览</el-button>
                </div> 
            </div>
            <el-table
                :data="data"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                :tree-props="{children: 'children'}">
                <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column>
                <el-table-column prop="text" label="界面展示内容" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="attributes.componentType" label="组件类型" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.componentType == 1">
                            标签
                        </div>
                        <div v-else-if="scope.row.attributes.componentType == 2">
                            单行文本框
                        </div>
                        <div v-else-if="scope.row.attributes.componentType == 3">
                            多行文本框
                        </div>
                        <div v-else-if="scope.row.attributes.componentType == 4">
                            图片与视频
                        </div>
                        <div v-else-if="scope.row.attributes.componentType == 5">
                            签名
                        </div>
                        <div v-else-if="scope.row.attributes.componentType == 6">
                            图片与视频+附件
                        </div>
                        <div v-else-if="scope.row.attributes.componentType == 7">
                            自定义(JSON格式)
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.operateType" label="操作类型" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.operateType == 1">
                            一级目录
                        </div>
                        <div v-else-if="scope.row.attributes.operateType == 2">
                            二级目录
                        </div>
                        <div v-else-if="scope.row.attributes.operateType == 3">
                            三级目录
                        </div>
                        <div v-else-if="scope.row.attributes.operateType == 4">
                            四级目录
                        </div>
                        <div v-else-if="scope.row.attributes.operateType == 5">
                            五级目录
                        </div>
                        <div v-else-if="scope.row.attributes.operateType == 9">
                            填写
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="attributes.componentShowUsersName" label="拥有权限的人" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.componentShowUsers != null
                            &&  scope.row.attributes.componentShowUsers!='' ">
                            {{scope.row.attributes.componentShowUsers}}
                        </div>
                        <div v-else>
                            全部
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="attributes.checkUserName" label="审核人(审批类型才有审核人)" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.checkUser != null
                            &&  scope.row.attributes.checkUser!='' ">
                            {{scope.row.attributes.checkUser}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="110px">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="setAdd(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <div v-if="templateConfigInfoVisible">
            <templateConfigInfo ref="templateConfigInfo"></templateConfigInfo>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import add from './Add.vue'; 
    import update from './Update.vue'; 
    import templateConfigInfo from './TemplateConfigInfo.vue'; 

    export default {
        name:"TemplateConfig",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                templateConfigInfoVisible:false,
                data:[],
                id:"",
                form:{
                    deptId:""
                },
                depts:[]
            }
        },
        components: {
            add,update,templateConfigInfo
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.teacherTemplateConfigListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(data){
                this.addVisible = true;
                this.$nextTick(() => {
                    this.$refs['add'].init(data,this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.teacherTemplateConfigRemoveUrl;
                let data = {
                    id:this.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip("删除成功",1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // 生成模板
            createTemplate(){

            },
            // 预览
            preview(){
                this.templateConfigInfoVisible = true;
                this.$nextTick(() => {
                    this.$refs['templateConfigInfo'].init(this.form.deptId);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/teacher/config/TemplateConfig.vue